(function () {
  'use strict';
  const weekdays = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  const own = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
  const minutes = value => Number(value.slice(0, 2)) * 60 + Number(value.slice(3));
  const clock = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  function validateSlot(slot) {
    if (slot === null) return;
    if (!Array.isArray(slot) || slot.length !== 2 ||
        !slot.every(t => typeof t === 'string' && clock.test(t)) ||
        minutes(slot[0]) >= minutes(slot[1])) throw new Error('Ungültige Öffnungszeit');
  }
  function validate(schedule) {
    if (!schedule || !schedule.weekly || !Array.isArray(schedule.months) ||
        !schedule.months.length || !schedule.months.every(m => Number.isInteger(m) && m >= 1 && m <= 12) ||
        !schedule.exceptions || Array.isArray(schedule.exceptions) ||
        typeof schedule.exceptions !== 'object') throw new Error('Ungültige Tabelle');
    for (let day = 0; day < 7; day++) {
      if (!own(schedule.weekly, day)) throw new Error('Wochentag fehlt');
      validateSlot(schedule.weekly[day]);
    }
    for (const [date, slot] of Object.entries(schedule.exceptions)) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) throw new Error('Ungültiges Datum');
      const parsed = new Date(date + 'T12:00:00Z');
      if (!Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date) {
        throw new Error('Ungültiges Datum');
      }
      validateSlot(slot);
    }
    return schedule;
  }
  function localParts(now) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit',
      day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(now).map(p => [p.type, p.value]));
    return {
      // UTC noon represents a calendar day, not an opening-time instant.
      day: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, 12)),
      minute: +parts.hour * 60 + +parts.minute
    };
  }
  function slotFor(schedule, day) {
    const key = day.toISOString().slice(0, 10);
    if (own(schedule.exceptions, key)) return schedule.exceptions[key];
    if (!schedule.months.includes(day.getUTCMonth() + 1)) return null;
    return schedule.weekly[day.getUTCDay()];
  }
  function status(schedule, now) {
    const local = localParts(now);
    const slot = slotFor(schedule, local.day);
    if (slot && local.minute < minutes(slot[1])) {
      return {state: local.minute >= minutes(slot[0]) ? 'open' : 'scheduled',
        kind: 'open', value: slot.join('–')};
    }
    // Do not imply an unconfirmed date months into the next season.
    for (let offset = 1; offset <= 7; offset++) {
      const next = new Date(local.day);
      next.setUTCDate(next.getUTCDate() + offset);
      const hours = slotFor(schedule, next);
      if (hours) return {state: 'closed', kind: 'next',
        value: weekdays[next.getUTCDay()] + ' ' + hours[0]};
    }
    return {state: 'closed', kind: 'unknown', value: ''};
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {validate, status};
  if (typeof window === 'undefined' || !window.customElements ||
      window.customElements.get('stepan-hours')) return;
  class StepanHours extends HTMLElement {
    connectedCallback() {
      this.label = this.querySelector('[data-stepan-hours-text]');
      if (!this.label) return;
      this.fallback = this.label.textContent;
      try { this.schedule = validate(JSON.parse(this.dataset.schedule)); }
      catch (_) { return; }
      this.refresh = () => {
        try {
          const result = status(this.schedule, new Date());
          const prefix = this.dataset[result.kind];
          if (!prefix) throw new Error('Status-Text fehlt');
          const text = prefix + (result.value ? ' ' + result.value : '');
          if (this.label.textContent !== text) this.label.textContent = text;
          this.dataset.state = result.state;
        } catch (_) {
          this.label.textContent = this.fallback;
          delete this.dataset.state;
        }
      };
      this.refresh();
      this.timer = window.setInterval(this.refresh, 30000);
      document.addEventListener('visibilitychange', this.refresh);
    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
    }
  }
  window.customElements.define('stepan-hours', StepanHours);
})();
